import { render, staticRenderFns } from "./PastServices.vue?vue&type=template&id=0563541e&scoped=true&"
import script from "./PastServices.vue?vue&type=script&lang=js&"
export * from "./PastServices.vue?vue&type=script&lang=js&"
import style0 from "./PastServices.vue?vue&type=style&index=0&id=0563541e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563541e",
  null
  
)

export default component.exports